import { render, staticRenderFns } from "./editProductPro.vue?vue&type=template&id=61853abb&scoped=true"
import script from "./editProductPro.vue?vue&type=script&lang=js"
export * from "./editProductPro.vue?vue&type=script&lang=js"
import style0 from "./editProductPro.vue?vue&type=style&index=0&id=61853abb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61853abb",
  null
  
)

export default component.exports